import styled, { keyframes } from 'styled-components';
import { colors } from '../../styles';

export const SpinContainer = styled.div`
  width: 100%;
  min-height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const expandKeyframe = keyframes`
  0% {
    top: 6px;
    height: 51px;
  }
  50%, 100% {
    top: 19px;
    height: 26px;
  }
`;

export const StyledSpinner = styled.div`
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;

  div {
    display: inline-block;
    position: absolute;
    left: 6px;
    width: 13px;
    background: ${colors.coupGreen};
    animation: ${expandKeyframe} 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  }

  div:nth-child(1) {
    left: 6px;
    animation-delay: -0.24s;
  }

  div:nth-child(2) {
    left: 26px;
    animation-delay: -0.12s;
  }

  div:nth-child(3) {
    left: 45px;
    animation-delay: 0;
  }
`;
